import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, matchPath } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar/Navbar';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';

// Pages
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Events from './pages/Events/Events';
import EventDetail from './pages/EventDetail/EventDetail';
import EventForm from './pages/EventForm/EventForm';
import InviteForm from './pages/InviteForm/InviteForm';
import GuestForm from './pages/GuestForm/GuestForm';
import RSVP from './pages/RSVP/RSVP';
import NotFound from './pages/NotFound/NotFound';

import './styles/global.scss';
import Home from './pages/Home/Home';

// Routes that show the navbar. Unmatched paths (404s) and /rsvp do not.
const NAV_ROUTES = [
  '/login',
  '/dashboard',
  '/events',
  '/events/new',
  '/events/:eventId',
  '/events/:eventId/edit',
  '/events/:eventId/invites/new',
  '/events/:eventId/invites/:inviteId/edit',
  '/events/:eventId/invites/:inviteId/guests/new',
  '/events/:eventId/invites/:inviteId/guests/:guestId/edit',
];

const AppContent: React.FC = () => {
  const location = useLocation();
  const showNavbar = NAV_ROUTES.some(pattern => matchPath(pattern, location.pathname));
  const hostname = window.location.hostname;

  return (
    <div className="app">
      {showNavbar && <Navbar />}
      <main>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/rsvp" element={<RSVP />} />
          {hostname === 'www.alexlibbywedding.co.uk' && <Route path="/" element={<Home />} />}
          <Route path="/rsvp/:eventCode" element={<RSVP />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/events"
            element={
              <PrivateRoute>
                <Events />
              </PrivateRoute>
            }
          />
          <Route
            path="/events/new"
            element={
              <PrivateRoute>
                <EventForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/events/:eventId"
            element={
              <PrivateRoute>
                <EventDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/events/:eventId/edit"
            element={
              <PrivateRoute>
                <EventForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/events/:eventId/invites/new"
            element={
              <PrivateRoute>
                <InviteForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/events/:eventId/invites/:inviteId/edit"
            element={
              <PrivateRoute>
                <InviteForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/events/:eventId/invites/:inviteId/guests/new"
            element={
              <PrivateRoute>
                <GuestForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/events/:eventId/invites/:inviteId/guests/:guestId/edit"
            element={
              <PrivateRoute>
                <GuestForm />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;
